import images from "./images";

const projects = [
  {
    id: 1,
    image: images.project1,
    title: "Package Design",
    details: {
      date: "March 18, 2024",
      client: "Urban Loft Interiors",
      category: "Gift Packaging",
      duration: "6 Weeks",
      location: "Downtown Seattle, WA",
      leadDesigner: "Samantha Woodrow"
    },
    paragraphs: [
      "This Package Design project focused on delivering a refined gift packaging solution that enhances product appeal and reflects brand elegance. Designed for a premium client, the packaging emphasized both form and function to leave a lasting impression.",
      "We used a mix of sustainable materials, precise structural engineering, and decorative finishes like gold foiling and die-cut inserts to create a luxurious, tactile experience. Every element was crafted to ensure a memorable unboxing while aligning with the client’s brand values."
    ],
    gallery: [
      images.project1Gallery1,
      images.project1Gallery2,
    ],
    procedure: [
      "Concept development and sketches",
      "Material selection and prototype testing",
      "Custom die-line creation and structural design",
      "Foiling and embossing refinement",
      "Client feedback integration",
      "Final production and delivery"
    ],
    results: [
      "Created premium packaging with high shelf appeal",
      "Enhanced customer experience through tactile design",
      "Improved product protection and brand identity",
      "Strengthened the client’s visual merchandising",
      "Delivered on time within budget constraints",
      "Received excellent client and customer feedback"
    ]
  },
  {
    id: 2,
    image: images.project2,
    title: "Graphic T-Shirt",
    details: {
      date: "April 10, 2024",
      client: "Creative Streetwear Co.",
      category: "T-Shirt Printing",
      duration: "4 Weeks",
      location: "Austin, TX",
      leadDesigner: "Marcus Delgado"
    },
    paragraphs: [
      "This Graphic T-Shirt project aimed to blend bold artistic expression with high-quality printing techniques for a limited-edition streetwear collection. The designs focused on urban culture, symbolism, and typography to appeal to a style-conscious audience.",
      "We used premium cotton tees combined with vibrant screen printing and heat transfer methods to ensure color durability and design precision. Each piece was quality-checked for alignment, print clarity, and fabric comfort before packaging and delivery."
    ],
    gallery: [
      images.project2Gallery1,
      images.project2Gallery2,
    ],
    procedure: [
      "Client briefing and concept brainstorming",
      "Illustration and digital mockup creation",
      "Fabric selection and test print evaluations",
      "Screen setup and color calibration",
      "Bulk printing and curing process",
      "Final inspection and packaging"
    ],
    results: [
      "Produced a visually impactful T-shirt line",
      "Achieved long-lasting, vivid prints",
      "Strengthened the brand’s streetwear identity",
      "Ensured fabric comfort with top-grade materials",
      "Delivered within tight campaign timelines",
      "Gained high engagement on social platforms post-launch"
    ]
  },
  {
    id: 3,
    image: images.project3,
    title: "Greeting Card",
    details: {
      date: "February 5, 2024",
      client: "Evergreen Moments",
      category: "Card Design",
      duration: "2 Weeks",
      location: "Portland, OR",
      leadDesigner: "Natalie Chen"
    },
    paragraphs: [
      "This Greeting Card design project was created to celebrate heartfelt moments with elegance and charm. The client required a collection of seasonal and event-based cards that conveyed warmth, style, and personalization.",
      "We incorporated custom illustrations, unique die-cut shapes, and textured paper stock to add depth and distinction to each card. Typography, color palettes, and finishes like spot UV and embossing were carefully chosen to match the sentiment and occasion."
    ],
    gallery: [
      images.project3Gallery1,
      images.project3Gallery2,
    ],
    procedure: [
      "Client consultation and message exploration",
      "Moodboard creation and illustration drafts",
      "Card layout design and typography pairing",
      "Material and finish selection",
      "Proofing and design refinements",
      "Final print run and envelope pairing"
    ],
    results: [
      "Delivered a cohesive, themed greeting card set",
      "Enhanced emotional appeal through visual storytelling",
      "Achieved premium look with fine finishes",
      "Improved brand perception through personalization",
      "Cards received positive customer feedback and reuse",
      "Increased seasonal sales and repeat orders"
    ]
  },
  {
    id: 4,
    image: images.project4,
    title: "Quote Mug",
    details: {
      date: "January 22, 2024",
      client: "Morning Brew Gifts",
      category: "Mug Printing",
      duration: "1 Week",
      location: "San Diego, CA",
      leadDesigner: "Rachel Morrison"
    },
    paragraphs: [
      "The Quote Mug project was developed to deliver inspiring and aesthetic coffee mugs that resonate with daily motivation and personalized gifting. The objective was to create a collection of mugs with empowering quotes and elegant typography.",
      "We used high-quality ceramic materials paired with sublimation printing to ensure sharp, fade-resistant designs. Each quote was carefully styled to match the tone of the message, and the final products were gift-ready with branded packaging."
    ],
    gallery: [
      images.project4Gallery1,
      images.project4Gallery2,
    ],
    procedure: [
      "Client briefing and quote selection",
      "Typography and layout styling",
      "Color and mug style selection",
      "Sublimation setup and test prints",
      "Bulk mug printing and quality assurance",
      "Final packaging and delivery"
    ],
    results: [
      "Created a unique and meaningful mug collection",
      "Achieved vibrant and durable print quality",
      "Boosted client’s product line for seasonal sales",
      "Ensured design consistency across large orders",
      "Increased customer engagement through personalization",
      "Received excellent reviews for both design and quality"
    ]
  },
  {
    id: 5,
    image: images.project5,
    title: "Quote T-Shirt",
    details: {
      date: "May 3, 2024",
      client: "Inspire Apparel Co.",
      category: "T-Shirt Printing",
      duration: "3 Weeks",
      location: "Brooklyn, NY",
      leadDesigner: "Aaron Delgado"
    },
    paragraphs: [
      "The Quote T-Shirt project focused on crafting a fashion-forward collection that blends everyday comfort with motivational messaging. The client's vision was to launch a minimal yet expressive series of tees targeting the self-growth and lifestyle audience.",
      "Using breathable cotton fabrics and precise heat transfer vinyl printing, we ensured clean typography, long-lasting prints, and premium wearability. Each quote was hand-picked and styled with modern layouts to create a positive impact with visual appeal."
    ],
    gallery: [
      images.project5Gallery1,
      images.project5Gallery2,
    ],
    procedure: [
      "Message selection and font styling",
      "Mockup design and layout finalization",
      "Material sourcing and fabric testing",
      "Heat transfer setup and print validation",
      "Mass production and quality inspection",
      "Packaging and client handoff"
    ],
    results: [
      "Successfully launched an inspiring T-shirt collection",
      "Delivered soft-touch fabric with durable print finish",
      "Increased online engagement through relatable content",
      "Achieved consistent design placement across sizes",
      "Enhanced brand identity for the client",
      "Garnered strong positive reviews from customers"
    ]
  },
  {
    id: 6,
    image: images.project6,
    title: "Business Card",
    details: {
      date: "June 1, 2024",
      client: "Vertex Solutions",
      category: "Card Design",
      duration: "1 Week",
      location: "Chicago, IL",
      leadDesigner: "Lena Brooks"
    },
    paragraphs: [
      "The Business Card project focused on designing a sleek and professional visual identity for Vertex Solutions. The goal was to create a card that instantly communicates credibility, modernity, and brand alignment at every networking opportunity.",
      "We used matte-finish cardstock with embossed logos and subtle spot UV to emphasize key details. Clean typography and a bold layout ensured that the design stood out while remaining highly functional and easy to read."
    ],
    gallery: [
      images.project6Gallery1,
      images.project6Gallery2,
    ],
    procedure: [
      "Client briefing and brand analysis",
      "Initial design concepts and typography selection",
      "Color palette matching with corporate identity",
      "Mockup presentation and client revisions",
      "Final print prep with finishes (emboss/UV)",
      "Production and delivery"
    ],
    results: [
      "Developed a strong visual identity in card form",
      "Enhanced brand professionalism and recognition",
      "Produced high-quality prints with luxury finishes",
      "Enabled effective first impressions in meetings",
      "Delivered on a tight schedule with precision",
      "Received praise from both client and partners"
    ]
  },
  {
    id: 7,
    image: images.project7,
    title: "Picture Mug",
    details: {
      date: "May 15, 2024",
      client: "Momento Gifts",
      category: "Mug Printing",
      duration: "1 Week",
      location: "Orlando, FL",
      leadDesigner: "Jasmine Patel"
    },
    paragraphs: [
      "The Picture Mug project was designed to help customers capture and relive special memories through customized photo-printed mugs. The client wanted a clean, vibrant, and long-lasting print solution for both personal gifting and retail sales.",
      "Using advanced sublimation techniques, we transferred high-resolution images onto premium ceramic mugs. Each mug was carefully aligned and tested to ensure color accuracy, sharpness, and fade resistance after multiple washes."
    ],
    gallery: [
      images.project6Gallery1,
      images.project6Gallery2,
    ],
    procedure: [
      "Client image selection and approval",
      "Template setup and print alignment",
      "Sublimation preparation and color profiling",
      "High-temp transfer and quality inspection",
      "Packaging with custom labels",
      "Final delivery and follow-up"
    ],
    results: [
      "Produced vibrant, photo-quality mugs",
      "Maintained color accuracy and image clarity",
      "Enhanced personalization for gifting occasions",
      "Ensured durability through testing and QA",
      "Boosted product visibility in online stores",
      "Earned repeat orders and positive customer reviews"
    ]
  }

];

export default projects;